import { connect } from 'react-redux';
import { IState } from '../../store';
import { IMortgageCalculatorProps, MortgageCalculator } from '.';

export function mapStateToProps(state: IState): IMortgageCalculatorProps {
  return {
    mortgageWidgetMarkup: state.mortgageMeta.mortgageWidgetMarkup,
    tracking: state.tracking,
  };
}

export const MortgageCalculatorContainer = connect<IMortgageCalculatorProps>(mapStateToProps)(MortgageCalculator);
